.session-note-row {
	display: flex;
	width: 100%;
	background: none;
	border: 0;
	padding: 0;
	background-color: #0000;
	border-radius: 10px;
	height: 85px;
	gap: 2.5px;
}

.session-note-row-button {
	display: flex;
	gap: 14px;
	width: 100%;
	padding: 6px;
	cursor: pointer;
}

.session-note-row-button:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
}

.session-note-hover:hover {
	background-color: #ddd;
}

.note-textarea-wrapper {
	width: 100%;
	height: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
}

.note-thumbnail {
	width: 96px;
	height: 72px;
	border-radius: 10px;
	display: flex;
	place-content: center;
	align-items: center;
	overflow: clip;
	position: relative;
	flex-shrink: 0;
	cursor: pointer;
}

.note-thumbnail-overlay {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: #0007;
	display: flex;
	place-content: center;
	align-items: center;
	color: white;
	flex-direction: column;
	font-variant-numeric: tabular-nums;
	font-size: 14px;
}

.note-textarea {
	height: 100%;
	font-size: 13px;
	border: 1px solid #777;
	border-radius: 6px;
	resize: none;
	padding: 6px 32px 6px 8px;
	background: none;
}

.note-textarea:focus-visible {
	outline: none;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border: 1px solid var(--focus-outline-color-dark);
}

.note-textarea:hover {
	background-color: #f5f5f5;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
}

.note-textarea::-webkit-scrollbar {
	display: none;
}

.note-edit-buttons-holder {
	position: absolute;
	right: 8px;
	width: fit-content;
	display: flex;
	place-content: center;
	align-items: center;
	flex-direction: column;
	gap: 10px;
}

.note-edit-button {
	width: 24px;
	height: 24px;
	display: flex;
	place-content: center;
	align-items: center;
	padding: 0;
	border: 2px solid;
	border-radius: 4px;
	background: #fff;
	cursor: pointer;
}

.note-edit-button:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 2px;
}

.note-edit-button:hover {
	background-color: #e0e0e0;
}

.note-edit-button:disabled {
	background: #eee;
	cursor: default;
}

.note-content {
	display: flex;
	flex: 1 1 100%;
	user-select: text;
	font-size: 16px;
	overflow-x: clip;
	overflow-y: auto;
	text-align: left;
	white-space: pre-wrap;
}

.note-content::-webkit-scrollbar {
	width: 4px;
}

.menu-button-wrapper {
	display: flex;
	justify-content: center;
	height: 36px;
	margin: auto 10px auto 0;
}

.session-note-actions {
	display: flex;
	height: 100%;
}
